export const wordCount = (s: string): number =>
  s
    .trim()
    .split(' ')
    .filter((str) => str.length > 0).length;

/**
 * if isFocusModeSettingVisible is false, and asrPlexFeatureEnabled is enabled - we need to use ASRPlexDictation
 * if isFocusModeSettingVisible is false, and asrPlexFeatureEnabled is disabled - we need to use NvoqQueueProvider
 * if isFocusModeSettingVisible is true, isFocusModeOn on, and asrPlexFeatureEnabled is enabled - we need to use ASRPlexDictation
 * if isFocusModeSettingVisible is true, isFocusModeOn on, and asrPlexFeatureEnabled is disabled - we need to use ASRPlexDictation
 * if isFocusModeSettingVisible is true, isFocusModeOn off, and asrPlexFeatureEnabled is enabled - we need to use ASRPlexDictation
 * if isFocusModeSettingVisible is true, isFocusModeOn off, and asrPlexFeatureEnabled is disabled - we need to use NvoqQueueProvider
 */

export const checkShouldUseASRPlex = ({
  isFocusModeSettingVisible,
  isFocusModeOn,
  asrPlexFeatureEnabled,
}: {
  isFocusModeSettingVisible: boolean;
  isFocusModeOn: boolean;
  asrPlexFeatureEnabled: boolean;
}) => {
  const shouldUseASRPlex =
    // focus-mode toggle visible *and* switched ON  → always ASRPlex
    (isFocusModeSettingVisible && isFocusModeOn) ||
    // otherwise fall back to the feature flag
    (!isFocusModeSettingVisible && asrPlexFeatureEnabled) ||
    (isFocusModeSettingVisible && !isFocusModeOn && asrPlexFeatureEnabled);
  return shouldUseASRPlex;
};
